<template>
  <div>
    <div class="container-fluid" style="height: 65px">
      <div class="table-responsive" style="border: 1px solid #f5a623">
        <table class="table table-white">
          <thead>
            <tr>
              <!--  <th scope="col">#</th> -->

              <th scope="col">Elément</th>

              <th scope="col">Date</th>

              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="res in result" v-bind:key="res.id">
              <td>
               
                {{ res.nom }}
              
              </td>

              <!-- <td v-text="user.nom_chouffeur"></td> -->

              <td>
               {{ res.deleted_at }}
              </td>

              <td>
                <!--  <img delete_bloc_note
                  src="https://img.icons8.com/fluency/48/000000/delete-bookmark.png"
                /> -->
                <img
                  @click="restore(res.id)"
                  style="margin-left: 4px"
                  src="restore.png"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>



<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>


<script>
import Vue from "vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import { apiDomain } from "../../config";
import axios from "axios";
export default {
  components: { VueDatePicker },
  name: "register",
  data() {
    return {
     
      result: {},
      transformedArray: [],
      apiDomain: "https://apil.auto-turki.com",
    };
  },
  created() {
    this.fetchResults(this.$route.query.model);
   
  },
  mounted() {},
  computed: {},
  methods: {


    fetchResults(id) {
      fetch(`${apiDomain}/api/get/${id}`)
        .then((res) => res.json())
        .then((res) => {
          this.result= res;
        })
        .catch((err) => console.log(err));
    },

    restore(id) {
      axios.post(`${apiDomain}/api/restore/${id}/${this.$route.query.model}`).then((response) => {
        if (response.status == 200) {
          this.$noty.success("Bien restaurée.");
          this.fetchResults(this.$route.query.model);

        }
      });
    },
  
  },
};
</script>


<style>
.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: -6px;
}
img.preview {
  width: 50px;
  height: 173px;
  background-color: white;
  border: 1px solid #ddd;
}
</style>

